export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    console.error("[isInIframe]: ", e);
    return true;
  }
};
